var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3",
    "data-name": "\\uC0AC\\uAC01\\uD615 3",
    width: 40,
    height: 36,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uBCA1\\uD130_\\uACE0\\uAE09_\\uAC1C\\uCCB4",
    "data-name": "\\uBCA1\\uD130 \\uACE0\\uAE09 \\uAC1C\\uCCB4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21",
    "data-name": "\\uADF8\\uB8F9 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_20",
    "data-name": "\\uADF8\\uB8F9 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_24",
    "data-name": "\\uD328\\uC2A4 24",
    d: "M5.406,29.3H24.39l9.787,6.521a1.048,1.048,0,0,0,1.072.054,1.036,1.036,0,0,0,.553-.915V28.789c1.9-.8,4.2-2.532,4.2-4.853V5.367A5.393,5.393,0,0,0,34.594,0H5.406A5.393,5.393,0,0,0,0,5.367V23.936A5.393,5.393,0,0,0,5.406,29.3M2.088,5.367a3.31,3.31,0,0,1,3.318-3.3H34.594a3.31,3.31,0,0,1,3.319,3.3V23.936c0,1.215-1.827,2.633-3.468,3.143a1.04,1.04,0,0,0-.731.99v4.952l-8.424-5.614a1.043,1.043,0,0,0-.582-.176H5.406a3.31,3.31,0,0,1-3.318-3.3Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_25",
    "data-name": "\\uD328\\uC2A4 25",
    d: "M7.66,10.8H32.278a1.948,1.948,0,1,0,0-3.9H7.66a1.948,1.948,0,1,0,0,3.9m0-2.653H32.278a.7.7,0,1,1,0,1.409H7.66a.7.7,0,1,1,0-1.409",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_26",
    "data-name": "\\uD328\\uC2A4 26",
    d: "M7.66,16.516H32.278a1.948,1.948,0,1,0,0-3.9H7.66a1.948,1.948,0,1,0,0,3.9m0-2.653H32.278a.7.7,0,1,1,0,1.408H7.66a.7.7,0,1,1,0-1.408",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_27",
    "data-name": "\\uD328\\uC2A4 27",
    d: "M7.66,22.033H32.278a1.948,1.948,0,1,0,0-3.9H7.66a1.948,1.948,0,1,0,0,3.9m0-2.653H32.278a.7.7,0,1,1,0,1.408H7.66a.7.7,0,1,1,0-1.408",
    fill: "#231f20"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/주간.2fd3e2b2949115f78020477b51a75257.svg";
export { ForwardRef as ReactComponent };